// @vendor
const Immutable = require('immutable');
const get = require('lodash/object/get');

// @constants
const {
    BROKER_CONSULT_MIFID_FETCHING,
    BROKER_CONSULT_MIFID_FETCHING_SUCCESS,
    BROKER_CONSULT_MIFID_FETCHING_ERROR
} = require('constants/actionTypes');

const {
    BROKER_CONVENIENCE_MIFID_TEST_PREVIOUS_TEST_FETCHING,
    BROKER_CONVENIENCE_MIFID_TEST_PREVIOUS_TEST_SUCCESS,
    BROKER_CONVENIENCE_MIFID_TEST_PREVIOUS_TEST_ERROR,

    BROKER_CONSULT_RESULT_MIFID_FETCHING,
    BROKER_CONSULT_RESULT_MIFID_SUCCESS,
    BROKER_CONSULT_RESULT_MIFID_ERROR
} = require('mifid/constants/actionTypes');

const INITIAL_STATE = Immutable.fromJS({
    testDone: false,
    score: -1,
    fecha: '',
    evaluationDescription: '',
    questions: Immutable.List(),
    fetching: false,
    fetched: false,
    error: undefined,
    tests: [],
});

const consultMiFIDFetchingSuccess = (immState, response) => {
    return immState.merge({
        testDone: get(response, 'puntuacion.value', null) !== null,
        score: parseFloat(get(response, 'puntuacion.value')) || -1,
        fecha: get(response, 'fecha'),
        evaluationDescription: (get(response, 'puntuacion.descripcion', '') + '').trim(),
        questions: Immutable.fromJS(get(response, 'preguntasArray.preguntasArray', [])),
        loading: false,
        fetched: true
    });
};

function brokerConsultMiFIDReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case BROKER_CONVENIENCE_MIFID_TEST_PREVIOUS_TEST_FETCHING:
        case BROKER_CONSULT_MIFID_FETCHING:
            return INITIAL_STATE.merge({
                loading: true,
                fetched: false,
                error: null
            });
        case BROKER_CONVENIENCE_MIFID_TEST_PREVIOUS_TEST_SUCCESS:
        case BROKER_CONSULT_MIFID_FETCHING_SUCCESS:
            return consultMiFIDFetchingSuccess(state, action.payload.response);
        case BROKER_CONVENIENCE_MIFID_TEST_PREVIOUS_TEST_ERROR:
        case BROKER_CONSULT_MIFID_FETCHING_ERROR:
            return INITIAL_STATE.merge({
                loading: false,
                fetched: true,
                error: action.payload.error
            });
        case BROKER_CONSULT_RESULT_MIFID_FETCHING:
            return INITIAL_STATE.merge({
                fetching: true,
                error: false
            });
        case BROKER_CONSULT_RESULT_MIFID_SUCCESS:
            return INITIAL_STATE.merge({
                fetching: false,
                tests: action.payload,
                error: false
            });
        case BROKER_CONSULT_RESULT_MIFID_ERROR:
            return INITIAL_STATE.merge({
                fetching: false,
                tests: [],
                error: action.payload.error
            });
        default:
            return state;
    }
}

module.exports = brokerConsultMiFIDReducer;
